 <div class="app-content content login-background" *ngIf="isPageLoaded">
    <div class="content-overlay"></div>
    <div class="content-wrapper"  *ngIf="loading == false">
        <div class="content-header row">
        </div>
        <div class="content-body">
            <section class="row flexbox-container">
                <div class="col-12 d-flex flex-column align-items-center justify-content-center">
                    <h1 class="login-brand-title">Jung & Bosch MIS</h1>
                    <div class="col-lg-4 col-md-8 col-10 login-card-wrapper">
                        <div class="login-card">
                            <div class="login-card-header">
                            </div>
                            <div class="login-card-body">
                                <form class="login-form" [formGroup]="loginForm" (ngSubmit)="tryLogin()">
                                    <div class="form-group login-form-group">
                                        <label class="form-label">Benutzername</label>
                                        <div class="input-wrapper">
                                            <i class="la la-user input-icon"></i>
                                            <input type="text" 
                                                   formControlName="email" 
                                                   class="form-control login-input"
                                                   [ngClass]="{ 'is-invalid': submitted && f.email.errors }" 
                                                   id="user-name"
                                                   placeholder="Benutzername eingeben" 
                                                   required>
                                        </div>
                                        <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                            <div *ngIf="f.email.errors.required">Benutzername wird benötigt</div>
                                        </div>
                                    </div>
                                    <div class="form-group login-form-group">
                                        <label class="form-label">Passwort</label>
                                        <div class="input-wrapper">
                                            <i class="la la-key input-icon"></i>
                                            <input type="password" 
                                                   placeholder="Passwort eingeben"
                                                   formControlName="password" 
                                                   class="form-control login-input"
                                                   [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                                        </div>
                                        <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                                            <div *ngIf="f.password.errors.required">Passwort wird benötigt</div>
                                        </div>
                                    </div>
                                    <div class="form-group login-form-group login-form-footer">
                                        <div class="login-forgot-password">
                                            <a href="recover-password.html" class="forgot-link">Passwort vergessen?</a>
                                        </div>
                                    </div>
                                    <button type="submit" class="btn login-btn btn-block">
                                        <i class="fa fa-refresh fa-spin" *ngIf="submitted"></i>
                                        <i class="feather ft-unlock" *ngIf="!submitted"></i>
                                        <span *ngIf="!submitted">Anmelden</span>
                                        <span *ngIf="submitted">Wird angemeldet...</span>
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    </div>
</div>